import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isEmpty } from "../../Utils/utils";


const ActionToast = ({ msg, positiveBtnText, onSubmit, negativeBtnText, onCancel }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <span>{msg}</span>
        <div style={{ display: "flex", gap: "8px" }}>
            {
                !isEmpty(negativeBtnText) && <button
                    onClick={() => {
                        onCancel();
                        toast.dismiss();
                    }}
                    style={{
                        background: "#ccc",
                        border: "none",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                    }}
                >
                    {negativeBtnText}
                </button>
            }
            {
                !isEmpty(positiveBtnText) && <button
                onClick={() => {
                    onSubmit();
                    toast.dismiss();
                }}
                style={{
                    background: "#4caf50",
                    color: "white",
                    border: "none",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    cursor: "pointer",
                }}
            >
                {positiveBtnText}
            </button>
            }
        </div>
    </div>
);

export const showActionToast = ({ msg,
        positiveBtnText,
        onSubmit,
        negativeBtnText,
        onCancel,
        mDraggable = true }) => {
    toast(
        <ActionToast msg={msg} positiveBtnText={positiveBtnText} onSubmit={onSubmit} negativeBtnText={negativeBtnText} onCancel={onCancel} />,
        {
            position: "top-right",
            autoClose: false,
            closeOnClick: false,
            draggable: mDraggable,
            closeButton: false
        }
    );
};
